import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AccountFlagsFlowInterface, AccountFlagsFlowStateType, AccountFlagsFlowErrorType } from '@central-products/interface-account-flags-flow';
import { ACCOUNT_EVENT_IDS } from '@central-products/interface-account-actions';
import { FLAGS_CONFIG, INFO_FLAGS_CONFIG } from './constants';
import { AccountFlagsContainer } from './AccountFlagsContainer';
import './index.scss';
export var AccountFlagsFlow = /*#__PURE__*/function (_AccountFlagsFlowInte) {
  _inherits(AccountFlagsFlow, _AccountFlagsFlowInte);

  var _super = _createSuper(AccountFlagsFlow);

  function AccountFlagsFlow(config, dependencies) {
    var _this;

    _classCallCheck(this, AccountFlagsFlow);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "dependencies", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", AccountFlagsFlowStateType.NONE);

    _defineProperty(_assertThisInitialized(_this), "onStateChangedCallback", void 0);

    _defineProperty(_assertThisInitialized(_this), "domNode", null);

    _this.config = config;
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(AccountFlagsFlow, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
        var _window$performance, _window$performance$m;

        var isFlagSupported;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!INFO_FLAGS_CONFIG[this.config.jurisdiction].includes(payload.flag)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", {});

              case 2:
                if (!(this.state !== AccountFlagsFlowStateType.NONE)) {
                  _context2.next = 4;
                  break;
                }

                throw {
                  error: AccountFlagsFlowErrorType.INVALID_STATE
                };

              case 4:
                isFlagSupported = FLAGS_CONFIG[this.config.jurisdiction].hasOwnProperty(payload.flag);

                if (isFlagSupported) {
                  _context2.next = 7;
                  break;
                }

                throw {
                  error: AccountFlagsFlowErrorType.INVALID_STATE
                };

              case 7:
                (_window$performance = window.performance) === null || _window$performance === void 0 ? void 0 : (_window$performance$m = _window$performance.mark) === null || _window$performance$m === void 0 ? void 0 : _window$performance$m.call(_window$performance, 'cp:account-flags:start');
                this.render(payload);
                this.setState(AccountFlagsFlowStateType.STARTED);
                return _context2.abrupt("return", {});

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function start(_x) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "cancel",
    value: function () {
      var _cancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.state === AccountFlagsFlowStateType.NONE || this.domNode === null)) {
                  _context3.next = 2;
                  break;
                }

                throw {
                  error: AccountFlagsFlowErrorType.INVALID_STATE
                };

              case 2:
                ReactDOM.unmountComponentAtNode(this.domNode);
                document.body.removeChild(this.domNode);
                this.domNode = null;
                this.setState(AccountFlagsFlowStateType.NONE);
                return _context3.abrupt("return", {});

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function cancel() {
        return _cancel.apply(this, arguments);
      }

      return cancel;
    }()
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", {
                  state: this.state
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      this.onStateChangedCallback = callback;
    }
  }, {
    key: "render",
    value: function render(payload) {
      var _this2 = this;

      this.domNode = document.createElement('div');
      document.body.appendChild(this.domNode);
      var flagConfig = FLAGS_CONFIG[this.config.jurisdiction][payload.flag];

      var onClose = function onClose() {
        _this2.dependencies['account-actions'].execute({
          eventId: ACCOUNT_EVENT_IDS.ACCOUNT_FLAG_CLOSE_REQUESTED,
          context: {
            data: {
              flag: payload.flag,
              type: flagConfig.type
            },
            userFlow: 'account-flags'
          }
        });

        _this2.cancel();
      };

      var onSuccess = function onSuccess() {
        _this2.dependencies['account-actions'].execute({
          eventId: ACCOUNT_EVENT_IDS.ACCOUNT_FLAG_SUCCESS_REQUESTED,
          context: {
            data: {
              flag: payload.flag,
              type: flagConfig.type
            },
            userFlow: 'account-flags'
          }
        });

        _this2.cancel();
      };

      var onQuit = function onQuit() {
        _this2.dependencies['account-actions'].execute({
          eventId: ACCOUNT_EVENT_IDS.ACCOUNT_FLAG_QUIT_REQUESTED,
          context: {
            data: {
              flag: payload.flag,
              type: flagConfig.type
            },
            userFlow: 'account-flags'
          }
        });

        _this2.cancel();
      };

      var onLoginRequested = function onLoginRequested() {
        _this2.dependencies['account-actions'].execute({
          eventId: ACCOUNT_EVENT_IDS.LOGIN_REQUESTED,
          context: {
            userFlow: 'account-flags'
          }
        });

        _this2.cancel();
      };

      var onActionRequested = function onActionRequested(eventId, context) {
        var isCloseRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        _this2.dependencies['account-actions'].execute({
          eventId: eventId,
          context: _Object$assign({}, context, {
            userFlow: 'account-flags'
          })
        });

        if (isCloseRequired) {
          _this2.cancel();
        }
      };

      var executeLogin = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(token) {
          var successEvent, _error$error, _error$error2;

          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (token) {
                    _context5.next = 3;
                    break;
                  }

                  onLoginRequested();
                  return _context5.abrupt("return");

                case 3:
                  _context5.prev = 3;
                  _context5.next = 6;
                  return _this2.dependencies['session-manager'].tokenLogIn({
                    token: token
                  });

                case 6:
                  successEvent = FLAGS_CONFIG[_this2.config.jurisdiction][payload.flag].successEvent;

                  if (successEvent) {
                    _context5.next = 9;
                    break;
                  }

                  return _context5.abrupt("return");

                case 9:
                  _this2.dependencies['account-actions'].execute({
                    eventId: successEvent,
                    context: {
                      userFlow: 'account-flags'
                    }
                  });

                  _context5.next = 15;
                  break;

                case 12:
                  _context5.prev = 12;
                  _context5.t0 = _context5["catch"](3);

                  if ((_context5.t0 === null || _context5.t0 === void 0 ? void 0 : (_error$error = _context5.t0.error) === null || _error$error === void 0 ? void 0 : _error$error.code) === 'error.authentication.hard.flag') {
                    _this2.cancel();

                    _this2.dependencies['account-actions'].execute({
                      eventId: ACCOUNT_EVENT_IDS.HARD_FLAG_REQUESTED,
                      context: {
                        data: _context5.t0 === null || _context5.t0 === void 0 ? void 0 : (_error$error2 = _context5.t0.error) === null || _error$error2 === void 0 ? void 0 : _error$error2.data,
                        userFlow: 'account-flags'
                      }
                    });
                  } else {
                    onLoginRequested();
                  }

                case 15:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, null, [[3, 12]]);
        }));

        return function executeLogin(_x2) {
          return _ref.apply(this, arguments);
        };
      }();

      ReactDOM.render( /*#__PURE__*/React.createElement(AccountFlagsContainer, {
        environment: this.config.environment,
        jurisdiction: this.config.jurisdiction,
        locale: this.config.locale,
        dataAccessService: this.dependencies['data-access-service'],
        flag: {
          source: payload.flag,
          context: payload.context,
          name: flagConfig.app,
          type: flagConfig.type,
          token: payload.token,
          settings: flagConfig.settings,
          options: flagConfig.options
        },
        onClose: onClose,
        onSuccess: onSuccess,
        onQuit: onQuit,
        onLoginRequested: onLoginRequested,
        onActionRequested: onActionRequested,
        executeLogin: executeLogin
      }), this.domNode);
    }
  }, {
    key: "setState",
    value: function setState(state) {
      if (this.state === state) {
        return;
      }

      this.state = state;

      if (this.onStateChangedCallback) {
        this.onStateChangedCallback({
          state: state
        });
      }
    }
  }]);

  return AccountFlagsFlow;
}(AccountFlagsFlowInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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